var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isValidEducation)?_c('div',[_c('h5',[_vm._v("Образование:")]),_c('p',[_vm._v(" "+_vm._s(_vm.composedEducation)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }